import { render } from "./StoreFundraising.vue?vue&type=template&id=4dad0707"
import script from "./StoreFundraising.vue?vue&type=script&lang=js"
export * from "./StoreFundraising.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__